import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@shopify/polaris';
import styleConstants from '../../styles/constants';

const LoadingState = ({ message }) => {
  return (
    <div className="loading-state__container">
      <h1>{message}</h1>
      <Spinner accessibilityLabel="Loading" color="teal" size="large" />
      <style jsx="">{`
        h1 {
          margin-bottom: ${styleConstants.spacing.four};
        }
        .loading-state__container {
          align-items: center;
          display: flex;
          flex-direction: column;
          height: 100vh;
          justify-content: center;
          width: 100%;
        }
      `}</style>
    </div>
  );
};

LoadingState.propTypes = {
  message: PropTypes.string,
};

LoadingState.defaultProps = {
  message: 'Loading',
};

export default LoadingState;
